var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createElement } from "react";
import classNames from "classnames";
import styles from "./icon.css";
var Icon = function (_a) {
    var _b;
    var type = _a.type, rootStyle = _a.rootStyle, iconStyle = _a.iconStyle, iconProps = _a.iconProps, _c = _a.onClick, onClick = _c === void 0 ? undefined : _c;
    return (_jsx("div", { className: classNames(rootStyle, (_b = {}, _b[styles.action] = onClick, _b)), onClick: onClick, children: createElement(type ? type.default : "div", __assign({ customStyle: iconStyle }, iconProps)) }));
};
import * as IconTypes from "./consts/consts";
export { IconTypes };
export default Icon;
